// Development Environment Configuration (for AWS builds)
// This file is used when running `ng build --configuration=development`
// It contains absolute URLs for the develop environment
export const environment = {
  production: false,
  environmentName: 'dev',
  // Setup onboarding stays on in dev so the flow can keep being built/tested.
  setupOnboardingEnabled: true,
  cognitoUserPoolId: 'us-east-1_Hvb5NAAMj', // client-app-user-pool-develop
  cognitoAppClientId: '1098n1uuoi4t2tm3lrk5m42iua',
  graphQlURI: 'https://develop.app.myvessel.com/graphql',
  wsGraphQlURI: 'wss://develop.app.myvessel.com/graphql-ws',
  termsAndPolicyLink: 'https://www.vesseltechnologies.com/legal',
  myVesselGuideLink: 'https://guide.app.myvessel.com/guide',
  appVersion: '3.6.3',
  appBuild: '36',

  // Coralogix monitoring
  coralogixApiKey: 'cxtp_AHHcWkSqWUwmxc2VnbVMnPw9iVYY8k',

  iotMqttUsername: 'unknown?x-amz-customauthorizer-name=customAuthorizer-dev',
  iotMqttPrefix: 'hadev',
  iotEndpoint: 'a363lr7rjuydny-ats.iot.us-east-1.amazonaws.com',
  iotLoginEndpoint: 'https://auth.dev.iot.myvessel.com/login',
  iotThingsEndpoint: 'https://api.dev.iot.myvessel.com/devices',

  // AWS Configuration
  awsRegion: 'us-east-1',
  awsAccountId: '629955769584',
  cognitoIdentityPoolId: 'us-east-1:b046af1c-8cd3-4979-9c71-a1330c5939f3',
  dynamoDBTableName: 'Resident-develop',

  // AWS Polly Configuration
  pollyVoice: 'Ruth', // Default generative voice (Female)
  pollyEngine: 'generative' as const, // Use generative engine for more natural voices
  
  // Lambda Functions
  updatePinLambdaUrl: 'https://o5ghjb4nefozv7eytkwz6uvwy40dwtqt.lambda-url.us-east-1.on.aws/',
  airtableLambdaUrl: 'https://tgnwjnjypf.execute-api.us-east-1.amazonaws.com/dev',
  tourAuthCodeLambdaUrl: 'https://cokldvg46b.execute-api.us-east-1.amazonaws.com/dev/tour-auth-code',
  tourVerifyCodeLambdaUrl: 'https://cokldvg46b.execute-api.us-east-1.amazonaws.com/dev/tour-verify-code',
  tourGetBuildingsLambdaUrl: 'https://cokldvg46b.execute-api.us-east-1.amazonaws.com/dev/tour-get-buildings',

  // Weather API (cached proxy)
  weatherCacheUrl: 'https://weather-dev.myvessel.com',

  // Chat API
  chatApiUrl: 'https://chat.iot.myvessel.com',

  analyticsEventsUrl: 'https://3sfcmvsldl.execute-api.us-east-1.amazonaws.com/events',

  // Camera relay session API (POST /session) — dev. From the vessel-camera-relay
  // terraform output `session_api_url` (development).
  cameraSessionUrl: 'https://k3tzomswl3.execute-api.us-east-1.amazonaws.com/session'
};